// extracted by mini-css-extract-plugin
export var animationContainer = "_ik-0";
export var asteriskIcon = "_ik-8";
export var conversationLeftSection = "_ik-4";
export var conversationListItem = "_ik-3";
export var conversationMiddleSection = "_ik-5";
export var conversationRightSection = "_ik-6";
export var detailsContent = "_ik-1";
export var listContainer = "_ik-7";
export var modalContent = "_ik-2";